import { render, staticRenderFns } from "./Add-Synonym-List.vue?vue&type=template&id=54856dfc&"
import script from "./Add-Synonym-List.vue?vue&type=script&lang=js&"
export * from "./Add-Synonym-List.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports